import { Skeleton } from './Loader';

const TableCard = ({ title, summary, toolbar, footer, className = '', children }) => (
  <div className={`card table-card ${className}`}>
    <div className="card-header flex flex-wrap items-center justify-between gap-3">
      <div className="flex flex-wrap items-baseline gap-x-4 gap-y-1">
        {title && <h5>{title}</h5>}
        {summary &&
          (summary.loading ? (
            <Skeleton w="140px" h="1.25rem" />
          ) : (
            <span className="text-base text-theme-secondarytextcolor dark:text-themedark-secondarytextcolor">
              {summary.label}{' '}
              <strong className="text-f-h6 text-theme-headings dark:text-themedark-headings">{summary.value}</strong>
            </span>
          ))}
      </div>
      {toolbar && <div className="flex flex-wrap items-center gap-2">{toolbar}</div>}
    </div>
    <div className="card-body !p-0">{children}</div>
    {footer && <div className="card-footer">{footer}</div>}
  </div>
);

export default TableCard;
